(function () {
  if (customElements.get('ce-product-media-model') !== undefined) {
    return;
  }

  class ProductMediaModel extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        modelViewer: 'model-viewer',
        buttonFeatured: '[data-button-featured]',
      };

      this.elements = null;

      this.handleClickButtonFeatured = this.handleClickButtonFeatured.bind(this);
      this.blur = this.blur.bind(this);
    }

    get currentState() {
      return this.getAttribute('current-state');
    }

    set currentState(value) {
      this.setAttribute('current-state', value);
    }

    static get observedAttributes() {
      return ['current-state'];
    }

    async attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'current-state':
          if (newValue !== null) {
            switch (newValue) {
              case 'inactive': {
                await customElements.whenDefined(this.selectors.modelViewer);

                const keyframes = [
                  { opacity: 0, visibility: 'hidden' },
                  { opacity: 0, visibility: 'visible', offset: 0.2 },
                  { opacity: 1, visibility: 'visible' },
                ];

                const options = { duration: 250, fill: 'both' };

                this.elements.modelViewer.classList.add('shopify-model-viewer-ui__disabled');
                this.elements.modelViewer.setAttribute('tabindex', '-1');
                this.elements.modelViewer.showPoster();

                const anim = this.elements.buttonFeatured.animate(keyframes, options);
                anim.addEventListener('finish', () => {
                  anim.commitStyles();
                  anim.cancel();
                });

                break;
              }
              case 'active': {
                await customElements.whenDefined(this.selectors.modelViewer);

                const keyframes = [
                  { opacity: 1, visibility: 'visible' },
                  { opacity: 0, visibility: 'visible', offset: 0.8 },
                  { opacity: 0, visibility: 'hidden' },
                ];

                const options = { duration: 250, fill: 'both' };

                const anim = this.elements.buttonFeatured.animate(keyframes, options);
                anim.addEventListener('finish', () => {
                  anim.commitStyles();
                  anim.cancel();

                  this.elements.modelViewer.dismissPoster();
                  this.elements.modelViewer.removeAttribute('tabindex');
                  this.elements.modelViewer.classList.remove('shopify-model-viewer-ui__disabled');

                  if (this.currentState === 'active') {
                    this.elements.modelViewer.shadowRoot.querySelector('.userInput').focus({ preventScroll: true });
                  }
                });

                break;
              }
            }
          }

          break;
      }
    }

    async parsedCallback() {
      this.elements = {
        modelViewer: this.querySelector(this.selectors.modelViewer),
        buttonFeatured: this.querySelector(this.selectors.buttonFeatured),
      };

      this.elements.buttonFeatured.addEventListener('click', this.handleClickButtonFeatured);

      this.currentState = 'inactive';

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      this.elements.buttonFeatured.removeEventListener('click', this.handleClickButtonFeatured);
    }

    handleClickButtonFeatured() {
      this.currentState = 'active';
    }

    blur() {
      this.currentState = 'inactive';
    }
  }

  customElements.define('ce-product-media-model', ProductMediaModel);
})();
